import { Link, useParams, useLocation } from "react-router-dom"
import { OUR_CAPABILITIES_SECTION_KEY, ROUTES } from "../../config/routes"
import { ReactComponent as JCXLogo } from "../../assets/navBar/JCXLogo.svg"
import NextPreviousBtn from "../internal-side-navigator/next-previous/NextPreviousBtn"
import { useSelector } from "react-redux"
import { selectHaveAQuote, selectLoggedInUser } from "../../redux-store/LoginAuthSlice"
import { CLIENT_TYPES } from "../../config/clientTypesAndIndustry"
import classNames from "classnames"
import { onboardingOrWholeCipEnum, onboardingStateEnum } from "../../AppConfig"
import { cipVersionEnum } from "../../AppConfig"
import AwardsModalEndClient from "../../pages/proposal-template/end-client/detail-page/detail-page-sections/components/modal/awards-modal/AwardsModalEndClient"
import { useToggle } from "../../hooks"
import { ReactComponent as WhiteRedJcxLogo } from "../../assets/navBar/JCLogoWhiteRed.svg"
import { ReactComponent as PolicyDocumentsV2Logo } from "../../assets/navBar/PolicyDocumentsV2Logo.svg"
import { ReactComponent as HandShake } from "../../assets/proposal-template/handshake.svg"
import { selectIsAwarded, selectIsOnboardingComplete, selectRequestCode, selectSalesPocEmail } from "../../layouts/proposal-template/ProposalTemplateEndClientSlice"
export const MAIN_NAV_KEYS = {
  DEFAULT: "default",
  OUR_SERVICES: "our_services",
  CASE_STUDY: "case_study",
  CASE_STUDY_HOME: "case_study_home",
  OUR_SERVICES_SUB_PAGES: "our_services_sub_pages",
  ABOUT_US: "about_us",
  OUR_CAPABILITIES: "our_capabilities",
  PROPOSAL_TEMPLATE_END_CLIENT_HOME: "proposal_template_end_client_home",
  PROPOSAL_TEMPLATE_END_CLIENT_INNER_PAGES: "proposal_template_end_client_inner_pages",
}


const HaveAQuote = ({ clientType, cipVersion }) => {
  const buttonText = cipVersion === cipVersionEnum[1] ? "Request For Proposal" : "Have A Quote?";
  return <Link to={ROUTES.RFQ.ROOT} className="no-underline">
    <div className="HaveAQuoteContainer mr-4">
      <p className="HaveAQuote  text-base">{buttonText}</p>
    </div>
  </Link>
}


export const toDisplayClientNav = (becomeClientUrl, cipVersion, onboardingComplete, showHaveAQuote, clientType, navItemClass, cipAccessControl, location) => {
  const urlSplit = location?.pathname?.split("/")
  const onboard = ROUTES.ONBOARDING_CLIENT.UNIQUE_FROM_CRP.replace("/", "");
  return (
    <div className="flex align-items-center">
      {
        (cipAccessControl?.accessRight === onboardingOrWholeCipEnum[1] && showHaveAQuote) && <HaveAQuote clientType={clientType} cipVersion={cipVersion} />
      }
      {!onboardingComplete && !urlSplit?.includes(onboard) &&
        <Link to={becomeClientUrl} className="no-underline">
          <p className="BecomeClientBtn text-base">Become A Client</p>
        </Link>
      }
      {cipAccessControl?.accessRight === onboardingOrWholeCipEnum[1] &&
        <>
          <Link className={classNames(" font-semibold text-base flex align-items-center no-underline ml-4", navItemClass)} to={ROUTES.ABOUT_US}>
            About Us
          </Link>
          <div className=" ml-4 border-left-2 h-1rem"></div>
          <Link className={classNames(" font-semibold text-base flex align-items-center no-underline ml-4", navItemClass)} to={ROUTES.FAQ}>
            FAQs
          </Link>
          <div className=" ml-4 border-left-2 h-1rem"></div>
        </>
      }
    </div>
  )
}

export const DisplayNavbarLeft = (navbarType, dispatch, navigate, identifierRoute, enableHomeLink, displayDarkLogo, displayPolicyV2Logo) => {
  const { pathname } = useLocation()

  const LogoComponent = () => {
    if (displayPolicyV2Logo) return <PolicyDocumentsV2Logo className="text-white" />
    if (navbarType === MAIN_NAV_KEYS.PROPOSAL_TEMPLATE_END_CLIENT_HOME || pathname.includes(ROUTES.PRICING_MATRIX.ROOT)) {
      return <WhiteRedJcxLogo className="text-white" />
    }
    return <JCXLogo />
  }

  return (
    <Link to={ROUTES.HOME} className={classNames({ "pointer-events-none": !enableHomeLink })}>
      <LogoComponent />
    </Link>
  )


}



export const NavbarRight = ({ navbarType, cipVersion, isLoggedIn, becomeClientUrl, handleSignOut, prevStudyRoute, nextStudyRoute, cipAccessControl, location, token }) => {
  const { [OUR_CAPABILITIES_SECTION_KEY]: sectionIdentifier } = useParams()
  const { pathname } = useLocation()

  const showHaveAQuote = useSelector(selectHaveAQuote)
  const reqCode = useSelector(selectRequestCode)
  const isAwarded = useSelector(selectIsAwarded)
  const [isAward, toggleAwards] = useToggle(false)
  const { onboardingComplete, clientType } = useSelector(selectLoggedInUser)
  const isOnboardingComplete = useSelector(selectIsOnboardingComplete)
  const spocMail = useSelector(selectSalesPocEmail)
  const navItemClass = { "text-900": sectionIdentifier, "text-white": !sectionIdentifier };
  if (pathname.includes(ROUTES.PRICING_MATRIX.ROOT)) {
    return (
      <div><img src="https://curatedprdstgacct.blob.core.windows.net/curated-prd/assets/rep_data_f975afe2a9.png" alt="REP_DATA" height={35} width={230} /></div>
    )
  }
  if (navbarType === MAIN_NAV_KEYS.CASE_STUDY) {
    return (
      <NextPreviousBtn prevRoute={prevStudyRoute} nextRoute={nextStudyRoute} prevText="Previous Study" nextText="next Study" textClass="" barClass="bg-white" />
    )
  }
  else if (navbarType === MAIN_NAV_KEYS.PROPOSAL_TEMPLATE_END_CLIENT_HOME || navbarType === MAIN_NAV_KEYS.PROPOSAL_TEMPLATE_END_CLIENT_INNER_PAGES) {
    return (
      <>
        <AwardsModalEndClient visible={isAward} onHide={toggleAwards} email={spocMail} reqCode={reqCode} isOnboardingComplete={isOnboardingComplete} />
        <div className={classNames(`AwardProject py-2 px-3 text-xs font-medium flex align-items-center ${(!token || (isAwarded && isOnboardingComplete)) ? "pointer-events-none opacity-60" : "cursor-pointer"}`)} onClick={() => toggleAwards(true)}>
          <HandShake className="mr-3" />
          Award <span className="ml-1 font-semibold text-sm">Project</span>
        </div></>
    )
  }
  else {
    if (isLoggedIn) {
      return (
        <div className={classNames("flex", navItemClass)}>
          {toDisplayClientNav(becomeClientUrl, cipVersion, onboardingComplete, showHaveAQuote, clientType, navItemClass, cipAccessControl, location)}
          {cipAccessControl?.accessRight === onboardingOrWholeCipEnum[1] &&
            <div onClick={handleSignOut} className=" font-semibold text-base flex align-items-center no-underline ml-4 cursor-pointer">
              Sign Out
            </div>
          }
        </div>
      )
    }
  }
}

export const becomeAClientURLFn = (cipAccessControl, currentUserId) => {
  // if (cipAccessControl?.onboardingState === onboardingStateEnum[0]) {
  //   return ROUTES.ONBOARDING_CLIENT.getStepPath(currentUserId)
  // }
  if (cipAccessControl?.onboardingState === onboardingStateEnum[1]) {
    return `${ROUTES.ONBOARDING_CLIENT.UNIQUE_FROM_CRP}/${ROUTES.ONBOARDING_CLIENT.ONBOARDING_WITHOUT_FORMS}/${currentUserId}/${ROUTES.ONBOARDING_CLIENT.ONBOARDING_CLIENT_INFO}`
  }
  else {
    return ROUTES.ONBOARDING_CLIENT.getStepPath(currentUserId)
    // return "#"
  }
}


export const navbarOnPageCondition = (navbarType) => {
  return (navbarType === MAIN_NAV_KEYS.OUR_SERVICES || navbarType === MAIN_NAV_KEYS.OUR_CAPABILITIES || navbarType === MAIN_NAV_KEYS.OUR_SERVICES_SUB_PAGES || navbarType === MAIN_NAV_KEYS.ABOUT_US)
}

export const handleSignOut = async ({ dispatch, logoutClient, navigate, resetClientCredentials, stepperMove }) => {
  dispatch(stepperMove(0))
  await logoutClient().unwrap()
  navigate(ROUTES.LOGIN)
  dispatch(resetClientCredentials())
  setTimeout(() => {
    window.location.reload();
  }, 500);
}